export default props => ({
	productId: props?.productId || null,
	quantity: 1,
	selectedOptions: {},
	variants: [],
	currentVariant: null,
	isAdding: false,
	success: false,
	error: null,

	init(props) {
		this.option = this.$refs.option
		// Parse product JSON from script tag
		try {
			const productJsonElement = this.$refs.productJson

			if (!productJsonElement) {
				console.error('Product JSON element not found')
				return
			}

			const productJson = JSON.parse(productJsonElement.innerHTML || '{}')
			this.variants = productJson.variants || []
			this.productId = productJson.id

			// Initialize selected options from the default variant
			if (this.variants.length > 0) {
				const defaultVariantId = productJson.current_variant

				const defaultVariant = defaultVariantId ? this.variants.find(v => v.id == defaultVariantId) : this.variants[0]

				this.currentVariant = defaultVariant

				// Set initial options based on the default variant
				this.selectedOptions = JSON.parse(productJsonElement.innerHTML || '{}').selectedOptions
			}

			// Watch for changes to selected options
			this.$watch('selectedOptions', () => {
				this.updateVariant()
			})
		} catch (error) {
			console.error('Error initializing product form:', error)
		}
	},

	increment() {
		this.quantity++
	},

	decrement() {
		if (this.quantity > 1) {
			this.quantity--
		}
	},

	updateOption(optionName, optionValue) {
		this.selectedOptions[optionName] = optionValue
	},

	updateVariant() {
		const selectedOptionsEntries = Object.entries(this.selectedOptions)

		if (selectedOptionsEntries.length === 0) return

		const matchingVariant = this.variants.find(variant => {
			if (!variant.options) return false

			return selectedOptionsEntries.every(([optionName, optionValue]) => {
				const option = variant.options.find(opt => opt.name === optionName)
				if (!option) return false

				return option.value === optionValue
			})
		})

		if (matchingVariant) {
			this.currentVariant = matchingVariant

			const idInput = this.$el.querySelector('[name="id"]')

			if (idInput) {
				idInput.value = matchingVariant.id
			}
		} else if (this.debug) {
			console.log('No matching variant found')
		}
	},

	isOptionAvailable(optionName, optionValue) {
		const testSelections = { ...this.selectedOptions }
		testSelections[optionName] = optionValue

		const matchingVariant = this.variants.find(variant => {
			if (!variant.options) return false

			const matches = Object.entries(testSelections).every(([name, value]) => {
				const option = variant.options.find(opt => opt.name === name)
				if (!option) return false

				const valueMatch = option.value === value
				return valueMatch
			})

			return matches
		})

		const isAvailable = matchingVariant && matchingVariant.available !== false

		return isAvailable
	},

	getAvailableOptionsFor(optionName) {
		const availableOptions = new Set()

		const currentSelections = { ...this.selectedOptions }
		delete currentSelections[optionName]

		this.variants.forEach(variant => {
			if (variant.available === false) return

			const matchesCurrentSelections = Object.entries(currentSelections).every(([name, value]) => {
				const option = variant.options.find(opt => opt.name === name)
				if (!option) return false

				return option.value === value
			})

			if (matchesCurrentSelections) {
				const option = variant.options.find(opt => opt.name === optionName)
				if (option) {
					availableOptions.add(option.value)
				}
			}
		})

		return Array.from(availableOptions)
	},

	get isAvailable() {
		return this.currentVariant?.available !== false
	},

	get currentPrice() {
		return this.currentVariant?.price || ''
	},

	get currentVariantId() {
		return this.currentVariant?.id || ''
	},

	get formattedPrice() {
		let price = this.currentPrice
		if (typeof price === 'string') {
			price = price.replace(/^\$/, '').trim()
		}
		return price
	},

	async submit() {
		this.isAdding = true
		this.error = null

		if (!this.isAvailable) {
			this.isAdding = false
			this.error = 'This product is sold out'
			return
		}

		const form = this.$el
		const formData = new FormData(form)
		const variant = formData.get('id')

		const payload = [
			{
				id: Number(variant),
				quantity: Number(this.quantity),
			},
		]

		const cart = this.$store.cart

		const res = await cart.addLines(payload)
		console.log(res)
		this.isAdding = false
		this.success = true
		setTimeout(() => {
			this.success = false
		}, 3000)
		// this.$store.header.openCart();
	},
})
